import React, { useState, useEffect } from "react";
import { getAllStudents } from "../../../services/StudentRecordService.js";

export default function AgentAnalyticsDetails({ initialData }) {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("overview"); // could add more tabs later

  useEffect(() => {
    const fetchStudents = async () => {
      setLoading(true);
      try {
        const data = await getAllStudents();
        const agentName = initialData?.agentName?.toLowerCase?.();
        const filtered = (data || []).filter(
          (s) => s?.formState?.agentName?.toLowerCase?.() === agentName
        );
        setStudents(filtered);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchStudents();
  }, [initialData]);

  if (loading) return <p>Loading analytics...</p>;

  // Compute analytics
  const voeCount = students.filter((s) => (s.formState?.enrolmentType || "COE").toLowerCase() === "voe").length;
  const coeCount = students.filter((s) => (s.formState?.enrolmentType || "COE").toLowerCase() === "coe").length;

  const lastStudent = students
    .slice()
    .sort((a, b) => (b.createdAt?.toDate?.()?.getTime?.() || 0) - (a.createdAt?.toDate?.()?.getTime?.() || 0))[0];

  const totalFeesDue = students.reduce((sum, s) => sum + ((s.formState?.feeAmount || 0) - (s.formState?.feePaid || 0)), 0);
  const dueStudents = students.filter((s) => (s.formState?.feeAmount || 0) > (s.formState?.feePaid || 0));

  return (
    <div style={{ padding: 20 }}>
      {/* Tabs */}
      <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
        <div
          onClick={() => setActiveTab("overview")}
          style={{
            padding: "8px 16px",
            cursor: "pointer",
            borderRadius: "6px 6px 0 0",
            background: activeTab === "overview" ? "#056ec4" : "#f0f0f0",
            color: activeTab === "overview" ? "#fff" : "#056ec4",
            fontWeight: 600,
          }}
        >
          Overview
        </div>
        <div
          onClick={() => setActiveTab("fees")}
          style={{
            padding: "8px 16px",
            cursor: "pointer",
            borderRadius: "6px 6px 0 0",
            background: activeTab === "fees" ? "#056ec4" : "#f0f0f0",
            color: activeTab === "fees" ? "#fff" : "#056ec4",
            fontWeight: 600,
          }}
        >
          Fees Due ({dueStudents.length})
        </div>
      </div>

      {/* Tab Content */}
      <div style={{ border: "1px solid #ddd", padding: 20, borderRadius: 8 }}>
        {activeTab === "overview" && (
          <div style={{ display: "flex", gap: 30 }}>
            <div style={cardStyle}>
              <h3>VOE Students</h3>
              <p>{voeCount}</p>
            </div>
            <div style={cardStyle}>
              <h3>COE Students</h3>
              <p>{coeCount}</p>
            </div>
            <div style={cardStyle}>
              <h3>Last Student Enrolled</h3>
              <p>{lastStudent ? `${lastStudent.formState.firstName} ${lastStudent.formState.lastName}` : "-"}</p>
            </div>
            <div style={cardStyle}>
              <h3>Total Students</h3>
              <p>{students.length}</p>
            </div>
          </div>
        )}

        {activeTab === "fees" && (
          <div>
            <h3>Fees Due Summary</h3>
            <p>Total Fees Due: ${totalFeesDue}</p>
            <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 10 }}>
              <thead>
                <tr style={{ borderBottom: "1px solid #ddd" }}>
                  <th style={thStyle}>Student</th>
                  <th style={thStyle}>Enrolment Type</th>
                  <th style={thStyle}>Fee Amount</th>
                  <th style={thStyle}>Fee Paid</th>
                  <th style={thStyle}>Due Amount</th>
                </tr>
              </thead>
              <tbody>
                {dueStudents.map((s) => {
                  const f = s.formState || {};
                  const due = (f.feeAmount || 0) - (f.feePaid || 0);
                  return (
                    <tr key={s.id} style={{ borderBottom: "1px solid #eee" }}>
                      <td style={tdStyle}>{f.firstName} {f.lastName}</td>
                      <td style={tdStyle}>{f.enrolmentType || "COE"}</td>
                      <td style={tdStyle}>${f.feeAmount || 0}</td>
                      <td style={tdStyle}>${f.feePaid || 0}</td>
                      <td style={tdStyle}>${due}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

const cardStyle = {
  padding: "16px",
  border: "1px solid #ddd",
  borderRadius: "8px",
  minWidth: "180px",
  textAlign: "center",
  background: "#f9f9f9",
};

const thStyle = {
  textAlign: "center",
  padding: "8px",
};

const tdStyle = {
  textAlign: "center",
  padding: "8px",
};
